/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_YesInputs */

const en_us2_workout_after_yes = /** @type {(inputs: Workout_After_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const pt_br2_workout_after_yes = /** @type {(inputs: Workout_After_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

const es_419_workout_after_yes = /** @type {(inputs: Workout_After_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const pt_pt2_workout_after_yes = /** @type {(inputs: Workout_After_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

const fr_fr2_workout_after_yes = /** @type {(inputs: Workout_After_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_de2_workout_after_yes = /** @type {(inputs: Workout_After_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_it2_workout_after_yes = /** @type {(inputs: Workout_After_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Workout_After_YesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_yes = /** @type {((inputs?: Workout_After_YesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_YesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_yes(inputs)
	if (locale === "es-419") return es_419_workout_after_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_yes(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_yes(inputs)
	if (locale === "de-DE") return de_de2_workout_after_yes(inputs)
	if (locale === "it-IT") return it_it2_workout_after_yes(inputs)
	return en_us2_workout_after_yes(inputs)
});
export { workout_after_yes as "workout-after.yes" }